<template>
  <a-layout>
    <div class="nav">
      <Breadcrumb />
    </div>
    <div class="content-container">
      <h1>演示环境，暂未开放</h1>
    </div>
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";

export default {
  components: {Breadcrumb}
}
</script>
<style>
.content-container {
  background-color: transparent;
}
</style>